import * as React from 'react';
import { Provider } from 'react-redux';
import { createAccountStore } from '../../../Account/store';
export const AccountStoreProvider = ({ children }) => {
    const store = React.useMemo(createAccountStore, []);
    return React.createElement(Provider, { store: store }, children);
};
export default AccountStoreProvider;
